export default "__VITE_ASSET__8dc553ad__"